import { type CustomWorkflowSummary } from '../../../store/customWorkflow/customWorkflows'

export type WorkflowEnablement = 'required' | 'organization' | 'enabled' | 'disabled'

export const workflowEnablement = (workflow: CustomWorkflowSummary, hasEnablement: boolean): WorkflowEnablement => {
  if (workflow.enforced) {
    return 'required'
  }
  if (!hasEnablement) {
    return 'disabled'
  }
  return workflow.level === 'account' ? 'organization' : 'enabled'
}
